const MODE_ASSET_CACHE = 'elmental-mode-assets-v1';
const MAX_MODE_CACHE_ENTRIES = 24;

let workerRegistrationStarted = false;
let modeWarmStarted = false;

export function registerAssetCacheWorker(): void {
  if (!import.meta.env.PROD || workerRegistrationStarted) return;
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  workerRegistrationStarted = true;
  const baseUrl = import.meta.env.BASE_URL || '/';
  const workerUrl = `${baseUrl}elmental-asset-cache-sw.js`;

  window.addEventListener('load', () => {
    void navigator.serviceWorker.register(workerUrl, { scope: baseUrl }).catch(() => {});
  }, { once: true });
}

export function warmModeImageCache(urls: readonly string[]): void {
  if (!import.meta.env.PROD || modeWarmStarted) return;
  if (typeof window === 'undefined' || !('caches' in window)) return;

  modeWarmStarted = true;
  const absoluteUrls = Array.from(new Set(urls.map((url) => new URL(url, window.location.href).href)));
  const warm = () => {
    void caches.open(MODE_ASSET_CACHE)
      .then(async (cache) => {
        await Promise.allSettled(
          absoluteUrls.map(async (url) => {
            const request = new Request(url, { cache: 'force-cache' });
            const cached = await cache.match(request);
            if (!cached) await cache.add(request);
          }),
        );
        await trimModeCache(cache);
      })
      .catch(() => {});
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(warm, { timeout: 1800 });
    return;
  }

  globalThis.setTimeout(warm, 600);
}

async function trimModeCache(cache: Cache): Promise<void> {
  const keys = await cache.keys();
  if (keys.length <= MAX_MODE_CACHE_ENTRIES) return;
  await Promise.all(keys.slice(0, keys.length - MAX_MODE_CACHE_ENTRIES).map((key) => cache.delete(key)));
}
